import type { ReactNode } from "react";

interface CarbonKpiCardProps {
  label: string;
  value: string;
  icon: string;
  color?: "primary" | "accent" | "secondary";
  subtitle?: string;
  children?: ReactNode;
}

export default function CarbonKpiCard({
  label,
  value,
  icon,
  color = "primary",
  subtitle,
}: CarbonKpiCardProps) {
  const colorMap = {
    primary: {
      bg: "bg-primary-50",
      text: "text-primary-600",
      border: "border-primary-100",
      value: "text-primary-700",
    },
    accent: {
      bg: "bg-accent-50",
      text: "text-accent-600",
      border: "border-accent-100",
      value: "text-accent-700",
    },
    secondary: {
      bg: "bg-secondary-50",
      text: "text-secondary-600",
      border: "border-secondary-100",
      value: "text-secondary-700",
    },
  };

  const c = colorMap[color];

  return (
    <div className="bg-white rounded-xl border border-background-200/70 p-4 md:p-5 hover:shadow-sm transition-shadow">
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-lg ${c.bg} flex items-center justify-center shrink-0`}>
          <i className={`${icon} ${c.text} w-full h-full flex items-center justify-center text-lg`} />
        </div>
        <div className="min-w-0">
          <div className="text-xs text-foreground-500 font-medium mb-0.5">{label}</div>
          <div className={`text-xl md:text-2xl font-bold ${c.value} font-heading`}>{value}</div>
          {subtitle && <div className="text-[11px] text-foreground-400 mt-1">{subtitle}</div>}
        </div>
      </div>
    </div>
  );
}